import { render, staticRenderFns } from "./ml.vue?vue&type=template&id=32fc3211&scoped=true"
import script from "./ml.vue?vue&type=script&lang=ts"
export * from "./ml.vue?vue&type=script&lang=ts"
import style0 from "./ml.vue?vue&type=style&index=0&id=32fc3211&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fc3211",
  null
  
)

export default component.exports